import * as React from "react";
import { Input } from "@jhool-io/fe-components";
import { ConsentTextFieldConfig } from "../../types/client-forms.types";

interface ConsentPaymentCardStepProps {
    renderForm: (onSaved: () => void | Promise<void>) => React.ReactNode;
    onSaved: () => void | Promise<void>;
    acknowledgementText?: string;
    initials?: string;
    initialsLabel?: string;
    onInitialsChange?: (value: string) => void;
    additionalInitialsFields?: ConsentTextFieldConfig[];
    additionalInitials?: Record<string, string>;
    onAdditionalInitialsChange?: (key: string, value: string) => void;
    fieldError?: string;
    onInteract?: () => void;
}

export default function ConsentPaymentCardStep({
    renderForm,
    onSaved,
    acknowledgementText,
    initials,
    initialsLabel,
    onInitialsChange,
    additionalInitialsFields,
    additionalInitials,
    onAdditionalInitialsChange,
    fieldError,
    onInteract,
}: ConsentPaymentCardStepProps) {
    return (
        <>
            <h2 className="text-sm font-semibold text-[#0B132B] mb-12">
                Add a payment card
            </h2>
            <div className="mb-20">
                <p className="text-sm text-[rgba(11,19,43,0.65)] mb-16">
                    Add a valid card to continue with your consent form.
                </p>
                {renderForm(onSaved)}
            </div>

            {acknowledgementText && (
                <div className="border-t border-strokelight pt-16 space-y-12">
                    <p className="text-sm text-[#0B132B] leading-relaxed whitespace-pre-line">
                        {acknowledgementText}
                    </p>

                    {onInitialsChange && (
                        <Input
                            id="card-step-initials"
                            label={initialsLabel ?? "Initials"}
                            type="text"
                            value={initials ?? ""}
                            onChange={(event) => {
                                if (onInteract) onInteract();
                                onInitialsChange(event.target.value);
                            }}
                            maxLength={10}
                            placeholder="e.g. J.D."
                        />
                    )}

                    {additionalInitialsFields?.map((field) => (
                        <Input
                            key={field.key}
                            id={`card-step-initials-${field.key}`}
                            label={field.label}
                            type="text"
                            value={additionalInitials?.[field.key] ?? ""}
                            onChange={(event) => {
                                if (onInteract) onInteract();
                                onAdditionalInitialsChange?.(
                                    field.key,
                                    event.target.value
                                );
                            }}
                            maxLength={10}
                            placeholder="e.g. J.D."
                        />
                    ))}

                    {fieldError && (
                        <p className="text-xs text-red-500">{fieldError}</p>
                    )}
                </div>
            )}
        </>
    );
}
